import { Controller } from "@hotwired/stimulus"
import { configure } from '~/routes'

export default class ActionJSController extends Controller {
    connect() {
        let body = document.querySelector('body');
        let programme_identifier = body.getAttribute('data-programme-identifier');

        if (programme_identifier != "") {
            configure({
                default_url_options: {programme_identifier: programme_identifier}
            });
        }

        let action = (body.getAttribute('data-action-js') || '').split('.');

        if (typeof ActionJS[action[0]] === 'object' && typeof ActionJS[action[0]][action[1]] === 'function') {
            ActionJS[action[0]][action[1]]();
        }


      // Additionally call legacy code that used to rely on turbolinks:load
      // Do not add new calls here. Instead create a new stimulus controller for your use case.
      window.initPluginDefaults();
      window.initModalDialogs();
      window.AdaliaViewer.init();
      window.AdaliaForm.init();
      window.AdaliaForm.highlightErrors();  
      window.ActionJS.Applicant._ready();
      window.initAdaliaDiscussions();
      window.ConfirmFormExit.init();
      window.tokenRefreshInit();
      window.toggleCollapse();
      window.sidebarResize();
      window.recoverScrollPosition();
      window.calculateEvaluationScores();
      window.ExternalIntegration.load();
      window.ProjectCall.ready();
      window.ResizablePages.init();
      window.initSiteHelpData();
      window.initSMSConfirmation();
      window.legacyMonitoringInit();
      window.ame.ready();
    }

    disconnect() {
      // Additionally call legacy code that used to rely on turbolinks:page-unload
      window.ActionJS.Applicant._cleanup();
    }
}
